
query studentDataloads($teamId: ID, $tz: String) {
  studentDataloads(teamId: $teamId) {
    id
    canCurrentEdit
    status
    teacher {
      id
      email
      first
      last
      isCurrent
    }
    insertedAt(tz: $tz)
  }
}
